import { CONTACT, INSTAGRAM_POSTS } from "@/lib/brand";
import { Instagram, ArrowUpRight } from "lucide-react";

export default function InstagramFeed() {
  return (
    <section
      id="instagram"
      data-testid="instagram-section"
      className="py-24 md:py-32 canvas-soft"
    >
      <div className="mx-auto max-w-6xl px-6 md:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-block text-xs tracking-[0.28em] uppercase font-semibold text-[#cb05a5]">
            @{CONTACT.instagramHandle}
          </span>
          <h2 className="mt-3 font-display font-black text-4xl sm:text-5xl text-slate-900 tracking-tight">
            Follow our journey.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {INSTAGRAM_POSTS.slice(0, 6).map((p, i) => (
            <a
              key={i}
              href={p.url}
              target="_blank"
              rel="noreferrer"
              data-testid={`instagram-tile-${i}`}
              className="group relative overflow-hidden rounded-2xl aspect-square sb-shadow hover:sb-shadow-lg transition-all"
            >
              <img
                src={p.image}
                alt={p.caption}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity"
                style={{
                  background:
                    "linear-gradient(135deg, rgba(41,159,224,0.72) 0%, rgba(203,5,165,0.72) 100%)",
                }}
              />
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <Instagram size={32} className="text-white" strokeWidth={1.6} />
              </div>
            </a>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-slate-600 max-w-xl mx-auto leading-relaxed">
            Follow us on Instagram{" "}
            <span className="font-semibold text-[#cb05a5]">
              @{CONTACT.instagramHandle}
            </span>{" "}
            for daily desk inspiration, fresh arrivals and behind-the-scenes
            moments.
          </p>
          <a
            href={CONTACT.instagramUrl}
            target="_blank"
            rel="noreferrer"
            data-testid="follow-instagram-btn"
            className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full text-white font-semibold shadow-lg hover:-translate-y-0.5 transition-transform"
            style={{
              background:
                "linear-gradient(135deg, #f58529 0%, #dd2a7b 40%, #8134af 75%, #515bd4 100%)",
            }}
          >
            <Instagram size={16} />
            Follow on Instagram
            <ArrowUpRight size={14} />
          </a>
        </div>
      </div>
    </section>
  );
}
